// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"b6616699","126":"a12f2775","171":"099b8571","200":"faf53f38","374":"77f6692c","417":"3bdf125d","453":"d50eda41","466":"2c1c8112","507":"50fbf036","536":"efb45d4e"}[chunkId] + ".chunk.js";
};